import React, { useState } from 'react';
import { Sparkles, Droplet, Heart, Palette, ChevronLeft, ChevronRight } from 'lucide-react';
const FeatureCard = ({
  icon,
  title,
  description
}) => {
  return <div className="bg-white rounded-xl shadow-sm p-6 space-y-4 transition-all hover:shadow-md" data-id="element-60">
      <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#f8e9e6]" data-id="element-61">
        {icon}
      </div>
      <h3 className="text-xl font-serif font-medium text-[#3a3a3a]" data-id="element-62">{title}</h3>
      <p className="text-[#5a5a5a]" data-id="element-63">{description}</p>
    </div>;
};
const BonusCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const bonuses = [{
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dsmqxvMK4hyibztFobT4e2/Kit_de_Belleza_en_Casa.png',
    label: 'BONUS #1 - GRATIS HOY',
    title: 'Kit de Belleza en Casa',
    description: 'Guía completa con todos los elementos esenciales para crear tu propio kit de belleza casero.'
  }, {
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vLsScKzwwDZL2umjKrhJwK/Planner_de_Belleza_en_Casa.png',
    label: 'BONUS #2 - GRATIS HOY',
    title: 'Planner de Belleza Económico',
    description: 'Organiza tu rutina de cuidado facial y lista de compras con productos accesibles que realmente funcionan.'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % bonuses.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + bonuses.length) % bonuses.length);
  };
  return <div className="relative max-w-2xl mx-auto" data-id="element-64">
      <div className="overflow-hidden" data-id="element-65">
        <div className="flex transition-transform duration-500 ease-out" style={{
        transform: `translateX(-${currentSlide * 100}%)`
      }} data-id="element-66">
          {bonuses.map((bonus, index) => <div key={index} className="w-full flex-shrink-0 px-4" data-id="element-67">
              <div className="bg-white p-6 rounded-xl shadow-lg border-2 border-[#b76e79]" data-id="element-68">
                <div className="bg-[#faf7f2] p-4 rounded-lg mb-4 h-48" data-id="element-69">
                  <img src={bonus.imageUrl} alt={bonus.title} className="w-full h-full object-contain" data-id="element-70" />
                </div>
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#f8e9e6] text-[#b76e79] text-xs font-bold mb-3" data-id="element-71">
                  {bonus.label}
                </div>
                <h4 className="text-lg font-medium text-[#3a3a3a] mb-2" data-id="element-72">
                  {bonus.title}
                </h4>
                <p className="text-[#5a5a5a]" data-id="element-73">{bonus.description}</p>
              </div>
            </div>)}
        </div>
      </div>
      <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white rounded-full p-2 shadow-lg hover:bg-[#f8e9e6] transition-colors" aria-label="Anterior" data-id="element-74">
        <ChevronLeft size={24} className="text-[#b76e79]" data-id="element-75" />
      </button>
      <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white rounded-full p-2 shadow-lg hover:bg-[#f8e9e6] transition-colors" aria-label="Siguiente" data-id="element-76">
        <ChevronRight size={24} className="text-[#b76e79]" data-id="element-77" />
      </button>
      <div className="flex justify-center gap-2 mt-6" data-id="element-78">
        {bonuses.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all ${currentSlide === index ? 'bg-[#b76e79] w-8' : 'bg-[#e9e2d9] hover:bg-[#d4c5ba]'}`} aria-label={`Ir al bonus ${index + 1}`} data-id="element-79" />)}
      </div>
    </div>;
};
const Features = () => {
  const features = [{
    icon: <Sparkles size={24} className="text-[#b76e79]" data-id="element-80" />,
    title: 'Belleza en casa',
    description: '50 remedios caseros que SÍ funcionan con ingredientes que tienes en la cocina.'
  }, {
    icon: <Droplet size={24} className="text-[#b76e79]" data-id="element-81" />,
    title: 'Guía de skincare para piel latina',
    description: 'Rutinas AM/PM y productos económicos que funcionan según tu tipo de piel.'
  }, {
    icon: <Heart size={24} className="text-[#b76e79]" data-id="element-82" />,
    title: 'Secretos de belleza de la abuela 2.0',
    description: 'Remedios reinventados y trucos para realzar tu belleza natural.'
  }, {
    icon: <Palette size={24} className="text-[#b76e79]" data-id="element-83" />,
    title: 'Maquíllate en 5 minutos',
    description: 'Paso a paso para un look rápido con "efecto buena cara" en tiempo récord.'
  }];
  return <section className="w-full py-16 md:py-24 bg-[#faf7f2]" data-id="element-84">
      <div className="container mx-auto px-4" data-id="element-85">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-86">
          <h2 className="text-3xl font-serif font-medium text-[#3a3a3a] mb-4" data-id="element-87">
            Presentamos: <span className="text-[#b76e79]" data-id="element-88">BELLEZA LATINA</span>
          </h2>
          <p className="text-lg text-[#5a5a5a]" data-id="element-89">
            La guía práctica y realista para cuidarte sin complicarte ni
            gastarte el sueldo
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-90">
          {features.map((feature, index) => <FeatureCard key={index} {...feature} data-id="element-91" />)}
        </div>
        <div className="mt-16 text-center" data-id="element-92">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#b76e79] text-white text-sm font-bold mb-6 animate-pulse" data-id="element-93">
            <Sparkles size={16} data-id="element-94" />
            <span data-id="element-95">¡SOLO POR HOY A COSTO $0!</span>
          </div>
          <h3 className="text-2xl font-serif font-medium text-[#3a3a3a] mb-8" data-id="element-96">
            Bonus especiales incluidos gratis
          </h3>
          <BonusCarousel data-id="element-97" />
        </div>
      </div>
    </section>;
};
export default Features;